const NotFound = () => <h1>Not found</h1>;
export default NotFound;
